import React from 'react';


const PasswordSection = () => (
  <>
    <div>
      <label htmlFor="currentPassword" className="block text-sm font-medium text-white">
        Current Password
      </label>
      <input
        type="password"
        id="currentPassword"
        name="currentPassword"
        className="mt-1 block w-full rounded-md bg-black text-white border border-gray-600 p-3 focus:ring focus:outline-none"
        required
      />
    </div>
    <div>
      <label htmlFor="newPassword" className="block text-sm font-medium text-white">
        New Password
      </label>
      <input
        type="password"
        id="newPassword"
        name="newPassword"
        className="mt-1 block w-full rounded-md bg-black text-white border border-gray-600 p-3 focus:ring focus:outline-none"
        required
      />
    </div>
    <div>
      <label htmlFor="confirmPassword" className="block text-sm font-medium text-white">
        Confirm New Password
      </label>
      <input
        type="password"
        id="confirmPassword"
        name="confirmPassword"
        className="mt-1 block w-full rounded-md bg-black text-white border border-gray-600 p-3 focus:ring focus:outline-none"
        required
      />
    </div>
  </>
);

export default PasswordSection;
